module.exports = __webpack_public_path__ + "static/media/boss-armor-red.d2ef095d.png";